import dayjs from 'common/dayjs';

export const DATETIME_VIEW_FORMATE = 'M/D(dd) HH:mm';

export const convertToIsoFormatFromDayAndHour = (day: string, hour: string) => {
  return dayjs(`${day} ${hour}`).tz().format().toString();
};

export const convertToViewFormatFromDateTime = (dateTime: string) => {
  return dayjs(dateTime).format(DATETIME_VIEW_FORMATE);
};
